import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import SocialFloatingButtons from "@/components/SocialFloatingButtons";
import ReweNav from "@/components/ReweNav";
import ReweFooter from "@/components/ReweFooter";

import Home from "./pages/Home";
import UeberUns from "./pages/UeberUns";
import Produkte from "./pages/Produkte";
import Service from "./pages/Service";
import Regionales from "./pages/Regionales";
import Karriere from "./pages/Karriere";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Barrierefreiheit from "./pages/Barrierefreiheit";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter >
        <ScrollToTop />
        <SocialFloatingButtons />
        <div className="bg-background text-foreground min-h-screen flex flex-col">
          <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-3 focus:rounded"
          >
            Zum Inhalt springen
          </a>
          <ReweNav />
          <main className="flex-1" id="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ueber-uns" element={<UeberUns />} />
              <Route path="/produkte" element={<Produkte />} />
              <Route path="/service" element={<Service />} />
              <Route path="/regionales" element={<Regionales />} />
              <Route path="/karriere" element={<Karriere />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/barrierefreiheit" element={<Barrierefreiheit />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <ReweFooter />
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;